<!-- Button trigger modal -->
<ng-container *ngIf="block">
  <button *ngFor="let item of block" type="button"
    class="btn button-modal w-100 mt-3 p-3 text-start d-flex justify-content-between align-items-center"
    data-bs-toggle="modal" [attr.data-bs-target]="'#Modal-'+item.id">
    <span class="text-uppercase ls-label-medium-semibold" [innerHTML]="item.label_cta"></span>
    <img loading="lazy" src="./assets/images/arrow-upper-right.png" alt="">
  </button>

  <!-- Modal -->
  <div *ngFor="let item of block" class="row modal fade w-100" id="{{'Modal-'+item.id}}" tabindex="0"
    aria-labelledby="sampleModalLabel" aria-hidden="true">
    <div class="col-12 modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="bg-color-modal-header">
          <div class="modal-header offset-5 px-5">
            <h3 class="modal-title ls-label-medium-semibold text-uppercase" [innerHTML]="item.label_cta"></h3>
            <button type="button" class="btn btn-transparent" data-bs-dismiss="modal" [attr.aria-label]="'Close'">
              <img loading="lazy" src="./assets/images/close.png" alt="icon-close">
            </button>
          </div>
        </div>
        <div class="modal-body p-5" [innerHTML]="helpersService.modifyLinks(item.testo_formattato, domainWebsite) | safeHtml"></div>
      </div>
    </div>
  </div>
</ng-container>